<template>
  <!-- 新手 -->

  <el-form ref="form" :model="form" :rules="rules" label-width="80px">
    <el-form-item label="文章详情" prop="content">
      <div class="editor-wrapper">
        <!-- 改进quill的图片base64功能，改为上传后拼接url，上传组件隐藏 -->
        <!-- :on-success="handleQuillImgSuccess" -->
        <el-upload
          class="quill-upload"
          :http-request="upload"
          action="#"
          :show-file-list="false"
          with-credentials
          accept="image/gif, image/jpeg, image/jpg, image/bmp, image/png"
          style="display: none"
        >
          <i id="imgInput" class="el-icon-plus avatar-uploader-icon" />
        </el-upload>
        <!--  -->
        <quill-editor
          ref="myQuillEditor"
          v-model="value"
          @change="onEditorChange($event)"
          :options="editorOption"
        />
      </div>
    </el-form-item>
    <el-button type="primary" @click="save">确 定</el-button>
  </el-form>
</template>

<script>
  import { addList, newsDetail, newsUpdate } from '@/api/xgcApi'
  import VabMarkdownEditor from '@/plugins/vabMarkdownEditor'
  import exoprt_file from '@/utils/expor_file' // 导出excel文件
  import { getUploadUrl } from '@/config'
  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'], // toggled buttons
    ['blockquote', 'code-block'],

    [{ header: 1 }, { header: 2 }], // custom button values
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
    [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
    [{ direction: 'rtl' }], // text direction

    [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
    [{ header: [1, 2, 3, 4, 5, 6, false] }],

    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    [{ font: [] }],
    [{ align: [] }],
    ['clean'], // remove formatting button
    ['image'],
  ]
  export default {
    name: 'TableEdit',
    components: { VabMarkdownEditor },
    data() {
      return {
        editorOption: {
          placeholder: '请输入内容',
          modules: {
            toolbar: {
              container: toolbarOptions,
              handlers: {
                // 重写点击组件上的图片按钮要执行的代码
                image: function (value) {
                  document
                    .querySelector('.quill-upload .el-upload__input')
                    .click()
                },
              },
            },
          },
        },
        upUrl: '/index/index/file', //上传图片的接口
        editor: null,

        form: {
          name: '',
          content: '',
        },
        rules: {
          content: [{ required: true, trigger: 'blur', message: '新闻详情' }],
        },
        title: '',
        radio: 1,
        dialogFormVisible: false,
        setList: false,
        value: '',
      }
    },
    created() {},
    methods: {
      /**
       *@name 富文本编辑器
       *@time 2024年4月23日15:01:58
       */
      // ---------------------------富文本编辑器开始--------------------------------------
      onEditorChange(e) {},
      upload(file) {
        // 图片上传
        file = file.file
        var data = {
          file: file,
          is_admin:1
        }
        var url = ''
        exoprt_file(this.upUrl, data).then((res) => {
          var pic = res
          let quill = this.$refs.myQuillEditor.quill
          // 获取光标所在位置
          let length = quill.getSelection().index
          // 插入图片 res.url为服务器返回的图片地址
          quill.insertEmbed(length, 'image', pic)
          // 调整光标到最后
          quill.setSelection(length + 1)
          // 调用编辑器的 insertEmbed 方法，插入URL
        })
      },

      // -----------------------------------------------------------------------------------------

      save() {
        this.form.content = this.value
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
            const { msg } = await newsUpdate(this.form)
            this.$baseMessage(msg, 'success')
            this.$refs['form'].resetFields()
            this.dialogFormVisible = false
            this.$emit('fetch-data')
            this.form = this.$options.data().form
          } else {
            return false
          }
        })
      },
    },
  }
</script>
<style>
  .ql-container {
    height: 400px;
  }
</style>
